import {useEffect, useRef, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {observer} from 'mobx-react';
import {Icon} from '@vidazoo/ui-kit';
import useChartsManager from '../../../../common/hooks/useChartsManager';
import useCloudManager from '../../../../common/hooks/useCloudManager';
import {ChartType} from '../../../../common/enums/ChartType';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import theme from './theme.module.scss';

export default observer(function DefaultCharts() {
    const chartsManager = useChartsManager();
    const cloud = useCloudManager();
    const {pathname} = useLocation();
    const [search, setSearch] = useState('');
    const input = useRef<HTMLInputElement>(null);
    const scroller = useRef<HTMLDivElement>(null);
    const charts = (chartsManager.navigationItems.data || []).filter(chart => chart.isDefault && chart.type === ChartType.DATA_TABLE)
        .sort((a, b) => (cloud.topCharts[b._id]?.count || 0) - (cloud.topCharts[a._id]?.count || 0));

    useEffect(() => {
        void cloud.initialize();
        void chartsManager.navigationItems.fetch();
    }, [cloud, chartsManager]);
    useEffect(() => {
        const element = scroller.current;
        if (!element) return;
        const onWheel = (event: WheelEvent) => {
            if (!event.deltaY || event.deltaX || element.scrollWidth <= element.clientWidth) return;
            event.preventDefault();
            element.scrollLeft += event.deltaY;
        };
        element.addEventListener('wheel', onWheel, {passive: false});
        return () => element.removeEventListener('wheel', onWheel);
    }, [charts.length]);

    if (!charts.length) return null;
    return <nav className={theme.shortcuts} aria-label="Chart shortcuts">
        <div className={theme.searchContainer}>
            <input ref={input} className={theme.search} aria-label="Search chart shortcuts" value={search}
                onChange={event => setSearch(event.target.value)}/>
            <button type="button" className={theme.searchButton} aria-label={search ? 'Clear chart search' : 'Search charts'}
                onClick={() => {if (search) setSearch(''); input.current?.focus();}}>
                <Icon size={2.2} iconName={search ? 'icon-cancel-small' : 'icon-search'}/>
            </button>
        </div>
        <div ref={scroller} className={theme.scroller}>
            {charts.filter(chart => chart.name.toLowerCase().includes(search.toLowerCase())).map(chart =>
                <Link key={chart._id} className={`${theme.shortcut} ${pathname.includes(chart._id) ? theme.selected : ''}`}
                    to={UrlsService.viewChart(chart._id)}>{chart.name}</Link>)}
        </div>
    </nav>;
});
